var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedFruitV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.299805,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5995 16.5841C9.20669 16.5841 8.02517 16.099 7.05494 15.1288C6.08472 14.1586 5.59961 12.9771 5.59961 11.5842C5.59961 10.4652 5.92996 9.46223 6.59066 8.57534C7.25137 7.68845 8.11743 7.09025 9.18884 6.78073C8.95075 6.7212 8.71861 6.6349 8.49242 6.5218C8.26623 6.40871 8.06385 6.26288 7.88529 6.08431C7.49244 5.69146 7.23946 5.2242 7.12637 4.68255C7.01328 4.14089 6.98649 3.5903 7.04601 3.03079C7.60553 2.97126 8.15612 2.99805 8.69777 3.11114C9.23943 3.22424 9.70669 3.47721 10.0995 3.87006C10.3733 4.14386 10.5727 4.45338 10.6977 4.79862C10.8227 5.14385 10.9031 5.50694 10.9388 5.88788C11.0936 5.51884 11.2811 5.17063 11.5013 4.84326C11.7215 4.51588 11.9686 4.21529 12.2424 3.94149C12.3733 3.81054 12.54 3.74506 12.7423 3.74506C12.9447 3.74506 13.1114 3.81054 13.2423 3.94149C13.3733 4.07244 13.4388 4.2391 13.4388 4.44148C13.4388 4.64386 13.3733 4.81052 13.2423 4.94147C12.9804 5.20337 12.7483 5.49206 12.5459 5.80753C12.3435 6.123 12.1947 6.4593 12.0995 6.81644C13.1471 7.14977 13.9923 7.75392 14.6352 8.62891C15.278 9.5039 15.5994 10.489 15.5994 11.5842C15.5994 12.9771 15.1143 14.1586 14.1441 15.1288C13.1739 16.099 11.9924 16.5841 10.5995 16.5841Z",
    fill: "#A847DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedFruitV2);
export default __webpack_public_path__ + "static/media/rounded-fruit-v2.7dc714bb330ad551dc0bf3c4a89e6730.svg";
export { ForwardRef as ReactComponent };